import { useState, Fragment, useEffect, useContext } from "react";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import { sendApiRequest } from "../../services/Base/base-service";

import SubNavigation from "../../components/Header/SubNavigation";
import PDFSidebar from "../../components/PfdSidebar";
import UserContext from "../../store/user-context";
import NotificationF24EditForm from "../../components/Forms/NotificationF24EditForm";
import { notifyUser } from "../../services/helpers";
import DocumentTypeEnum from "../../helpers/Enums/DocumentTypeEnum";

const NotificationF24Edit = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notificationF24PageInfo, setNotificationF24PageInfo] = useState(null);
  const [files, setFiles] = useState([]);
  const [invalidProperties, setInvalidProperties] = useState(null);
  const [f24PageNumber, setF24PageNumber] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [readyToBeVerified, setReadyToBeVerified] = useState(false);
  const [isPageValid, setIsPageValid] = useState(true);
  const [notificationPayments, setNotificationPayments] = useState(null);
  const [isVerified, setIsVerified] = useState(false);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const notificationId = params?.id;
  const clientId = params?.clientId;

  const userContext = useContext(UserContext);

  useEffect(() => {
    getNotificationPaymentFilesHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedFile !== null) {
      if (
        selectedFile.notificationPaymentAttachmentId === undefined ||
        selectedFile.notificationPaymentAttachmentId === null
      ) {
        setNotificationF24PageInfo(null);
        setNotificationPayments(null);
      } else {
        if (selectedFile.documentType === DocumentTypeEnum.F24) {
          getNotificationF24PageDataHandler(
            selectedFile.notificationPaymentAttachmentId,
            f24PageNumber
          );
          setNotificationPayments(null);
        } else if (
          selectedFile.documentType === DocumentTypeEnum.PaymentNotice
        ) {
          setNotificationF24PageInfo(null);
          getNotificationPagoPaPaymentHandler(
            selectedFile.notificationPaymentAttachmentId
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFile, f24PageNumber]);

  const getNotificationPaymentFilesHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `NotificationPaymentData/GetNotificationPaymentFiles/?notificationId=${notificationId}&clientId=${clientId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (response.data.notificationPaymentFiles !== null) {
            let files = [];
            response.data.notificationPaymentFiles.map((file) => {
              return files.push({
                name: file.fileName,
                fileContent: file.fileContent,
                isValid: file.isValid,
                notificationPaymentAttachmentId:
                  file.notificationPaymentAttachmentId,
                documentType: file.documentType,
              });
            });
            setReadyToBeVerified(
              files.every((file) => file.isValid) &&
                (invalidProperties === null || invalidProperties.length === 0)
            );
            setFiles(files);
            setSelectedFile(files[0]);
          }
        }
      }
    });
  };

  const getNotificationPagoPaPaymentHandler = (
    notificationPaymentAttachmentId
  ) => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `NotificationPaymentData/GetNotificationPagoPaPayment/?notificationPaymentAttachmentId=${notificationPaymentAttachmentId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setNotificationPayments(response.data.notificationPaymentsList);
          setIsLoading(false);
        }
      }
    });
  };

  const getNotificationF24PageDataHandler = (
    notificationPaymentAttachmentId,
    f24PageNumber
  ) => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `NotificationPaymentData/GetNotificationF24PageData/?notificationPaymentAttachmentId=${notificationPaymentAttachmentId}&pageNumber=${f24PageNumber}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setNotificationF24PageInfo(response.data.notificationF24Data);
          setInvalidProperties(response.data.invalidProperties);
          setIsPageValid(
            response.data.invalidProperties.length > 0 ? false : true
          );
          setIsLoading(false);
          setReadyToBeVerified(
            files.every((file) => file.isValid) &&
              response.data.invalidProperties.length === 0
          );
        }
      }
    });
  };

  const verifyF24DataNotificationHandler = (
    notificationPaymentAttachmentId
  ) => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `NotificationPaymentData/VerifyPaymentDataNotification`,
      "POST",
      true,
      { notificationPaymentAttachmentId },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          notifyUser(
            "Richiesta di notifica (verificata) aggiornata con successo!",
            "success",
            "it-check"
          );
          setTimeout(() => {
            navigate("/notificheAI/verificationf24");
          }, 3000);
        }
      }
    });
  };

  const fixInvalidNotificationF24Handler = (
    notificationAttachmentId,
    notificationData,
    pageNumber,
    notifyUser
  ) => {
    const inputs = document.querySelectorAll(".error-border");
    inputs.forEach((input) => {
      input.classList.remove("error-border");
      const inputParent = input.closest(".notifEditForm-input.form-group");
      if (inputParent !== null) {
        const errorMessage = inputParent.lastElementChild;
        inputParent.removeChild(errorMessage);
      }
    });
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `NotificationPaymentData/FixF24DataNotification`,
      "POST",
      true,
      {
        notificationId,
        notificationF24Data: notificationData,
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (response.data.result === false) {
            notifyUser(
              'La presenza di errori non rende possibile il salvataggio in stato "VERIFICATO" della richiesta di notifica.',
              "error",
              "it-close"
            );
            setInvalidProperties(response.data.invalidProperties);
            setIsLoading(false);
            setReadyToBeVerified(
              files.every((file) => file.isValid) &&
                response.data.invalidProperties.length === 0
            );
            setNotificationF24PageInfo((curState) => {
              return {
                ...curState,
                notificationF24PaymentRowInfos:
                  response.data.notificationF24PaymentRowInfos,
              };
            });
          } else if (response.data.result === true) {
            setIsLoading(false);
            getNotificationPaymentFilesHandler();
            setTimeout(() => {
              if (
                selectedFile !== null &&
                selectedFile.notificationPaymentAttachmentId !== undefined
              ) {
                getNotificationF24PageDataHandler(
                  selectedFile.notificationPaymentAttachmentId,
                  pageNumber
                );
              }
            }, 500);
          }
        }
      }
    });
  };

  const fixNotificationPagoPaPaymentHandler = (
    notificationAttachmentId,
    notifyUser
  ) => {
    const inputs = document.querySelectorAll(".error-border");
    inputs.forEach((input) => {
      input.classList.remove("error-border");
      const inputParent = input.closest(".notifEditForm-input.form-group");
      if (inputParent !== null) {
        const errorMessage = inputParent.lastElementChild;
        inputParent.removeChild(errorMessage);
      }
    });
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `NotificationPaymentData/FixNotificationPagoPaPayment`,
      "POST",
      true,
      {
        notificationAttachmentId,
        isVerified,
        notificationPayments: {
          notificationPaymentsList: notificationPayments,
        },
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (response.data.result === false) {
            notifyUser(
              'La presenza di errori non rende possibile il salvataggio in stato "VERIFICATO" della richiesta di notifica.',
              "error",
              "it-close"
            );
            setInvalidProperties(response.data.invalidProperties);
            setIsLoading(false);
          } else if (response.data.result === true) {
            setIsLoading(false);
            getNotificationPaymentFilesHandler();
            setTimeout(() => {
              if (
                selectedFile !== null &&
                selectedFile.notificationPaymentAttachmentId !== undefined
              ) {
                getNotificationPagoPaPaymentHandler(
                  selectedFile.notificationPaymentAttachmentId
                );
              }
            }, 500);
          }
        }
      }
    });
  };

  return (
    <Fragment>
      <SubNavigation
        page="editF24"
        notificationData={notificationF24PageInfo}
        setInvalidProperties={setInvalidProperties}
        setError={setError}
        setIsLoading={setIsLoading}
        files={files}
        fixInvalidNotificationF24Handler={fixInvalidNotificationF24Handler}
        f24PageNumber={f24PageNumber}
        readyToBeVerified={readyToBeVerified}
        verifyF24DataNotificationHandler={verifyF24DataNotificationHandler}
        notificationPayments={notificationPayments}
        fixNotificationPagoPaPaymentHandler={
          fixNotificationPagoPaPaymentHandler
        }
      />
      <Section>
        <h3 className="mb-5">Validazione dati acquisiti</h3>
        {error !== null && error.length !== undefined && !isLoading && (
          <div colSpan={12}>
            <Alert className="w-50 mx-auto" color="danger">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          </div>
        )}
        <Alert color="info" id="edit-alert">
          La sezione di modifica consente di verificare l'accuratezza
          dell'elaborazione dei documenti, effettuata dall'intelligenza
          artificiale. La colonna di sinistra mostra i documenti in formato PDF,
          mentre sulla colonna di destra è possibile visualizzare e modificare i
          campi interpretati erroneamente. Qualora fossero riscontrati errori di
          interpretazione, sarà possibile correggere facilmente le informazioni
          errate attraverso i campi di input forniti. Questa sezione consente di
          garantire che tutti i documenti siano completi e precisi prima di
          procedere con le successive attività.
        </Alert>
        <div className="position-relative">
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
        </div>
        {files.length > 0 && (
          <div className="content d-flex">
            <PDFSidebar
              files={files}
              setF24PageNumber={setF24PageNumber}
              setSelectedFileHandler={setSelectedFile}
              applyCost={
                notificationF24PageInfo?.notificationF24MainInfo.applyCost
              }
              isPageValid={isPageValid}
              setIsVerified={setIsVerified}
            />
            <NotificationF24EditForm
              notificationF24PageInfo={notificationF24PageInfo}
              setNotificationF24PageInfo={setNotificationF24PageInfo}
              invalidProperties={invalidProperties}
              notificationPayments={notificationPayments}
              setNotificationPayments={setNotificationPayments}
              isVerified={isVerified}
              setIsVerified={setIsVerified}
            />
          </div>
        )}

        {error === null && files.length === 0 && !isLoading && (
          <div colSpan={12}>
            <Alert className="w-50 mx-auto" color="info">
              Nessun risultato trovato!
            </Alert>
          </div>
        )}
        <div>
          <NotificationManager
            containerId="esempio-avanzato"
            fix="right"
            closeOnClick={true}
            state="success"
            duration={30000}
          />
        </div>
      </Section>
    </Fragment>
  );
};

export default NotificationF24Edit;
